import React from "react";
import "./index.css";

const Spinner = () => (
  <div className="app-spinner">
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Spinner;
